'use client';

import Custom404 from '@/components/Custom404';

export default function NotFound() {
  return <Custom404 />;
}
